import { render, staticRenderFns } from "./AccessControlPatient.vue?vue&type=template&id=b02a19ca&"
import script from "./AccessControlPatient.vue?vue&type=script&lang=js&"
export * from "./AccessControlPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports